import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";

const globalRightsReducer = (state = initialState.globalRights, action) => {
  switch (action.type) {
    case actionTypes.LOAD_GLOBAL_RIGHTS_STARTED: {
      return {
        ...state,
        loading: true
      };
    }

    case actionTypes.LOAD_GLOBAL_RIGHTS_SUCCESS: {
      return {
        ...action.payload,
        loading: false,
        loaded: true
      };
    }

    default: {
      return state;
    }
  }
};

export default globalRightsReducer;
